'use client'

import { useRef, useState } from 'react'

export function useVoicePlayer() {
  const audioRef = useRef<HTMLAudioElement | null>(null)
  const [playing, setPlaying] = useState(false)
  const [currentSrc, setCurrentSrc] = useState<string | null>(null)

  async function play(src: string): Promise<void> {
    try {
      if (audioRef.current) {
        audioRef.current.pause()
        audioRef.current = null
      }

      const audio = new Audio(src)
      audioRef.current = audio
      setCurrentSrc(src)
      setPlaying(true)

      await audio.play()

      await new Promise<void>((resolve, reject) => {
        audio.onended = () => {
          setPlaying(false)
          resolve()
        }
        audio.onerror = () => {
          setPlaying(false)
          reject(new Error(`Audio failed: ${src}`))
        }
      })
    } catch (err) {
      setPlaying(false)
      throw err
    }
  }

  function stop() {
    if (audioRef.current) {
      audioRef.current.pause()
      audioRef.current = null
    }
    setPlaying(false)
    setCurrentSrc(null)
  }

  return {
    play,
    stop,
    playing,
    currentSrc,
  }
}